import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Link from './Link';
import { Overlay } from 'react-bootstrap';

export default class Dropdown extends Component {

  constructor(props) {
    super(props);

    this.state = {
      open: false
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.location !== newProps.location) {
      this.setState({open: false});
    }
  }

  toggleOpen() {
    this.setState({open: !this.state.open});
  }

  onHide() {
    this.setState({open: false});
  }

  render() {

    var options = [];
    var value = this.props.placeholder;

    var parent = this;
    const loc = this.props.location;

    // types:
    // 0 overview
    // 1 admin
    // 2 ministry
    // 3 personal


    if (this.props.options != null && this.props.options.length !== 0) {
      let currentType = -1;
      this.props.options.sort((a, b) => { return a.type - b.type }).forEach(function(item, i) {
        if (currentType !== item.type) {
          currentType = item.type;
          switch (currentType) {
            case 0: options.push(<p key={i + "h"} className="Dropdown-header">Overview</p>); break;
            case 1: options.push(<p key={i + "h"} className="Dropdown-header">Administrative</p>); break;
            case 2: options.push(<p key={i + "h"} className="Dropdown-header">Ministries</p>); break;
            case 3: options.push(<p key={i + "h"} className="Dropdown-header">Personal</p>); break;
          }
        }
        options.push(<Link to={item.to} key={i} onClick={() => { parent.setState({open: false}) }}><div className="Dropdown-option">{item.label}</div></Link>);
      });
      if (loc !== "/") {
        var same = this.props.options.filter(function(item) {
          return (item.to === ("/" + loc.split("/")[1]) || item.to === ("/" + loc.split("/")[1]) + "/announcements");
        });
        if (same.length > 0) {
          value = same[0].label;
        }
      }
    }

    var classes = ['Dropdown-root']
    if (this.state.open) {
      classes.push('is-open');
    }

    const dropdown = (
      <div className={classes.join(' ')}>
        <div className="Dropdown-control" onClick={this.toggleOpen.bind(this)} ref="target">
          <div className="Dropdown-placeholder">
            {value}
          </div>
          <span className="Dropdown-arrow"></span>
        </div>
        <Overlay show={this.state.open} onHide={this.onHide.bind(this)} container={this} rootClose placement="bottom" target={() => ReactDOM.findDOMNode(this.refs.target)}>
          <div className="Dropdown-menu" style={{maxHeight: Math.min(window.innerHeight - 100, 500)}}>
            {options}
          </div>
        </Overlay>

      </div>
    );

    return (
      <div>
        {this.props.options == null && <p className="Dropdown-standin">Loading...</p>}
        {this.props.options != null && this.props.options.length === 0 && <p className="Dropdown-standin">You have not been given permissions to access any ministries, please contact the developer.</p>}
        {(this.props.options != null && this.props.options.length > 0) ? <div>{dropdown}</div> : null }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/util/Dropdown.js
 **/